import { render, staticRenderFns } from "./CreateConnectionInviteModal.vue?vue&type=template&id=44e95e92"
import script from "./CreateConnectionInviteModal.vue?vue&type=script&lang=js"
export * from "./CreateConnectionInviteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports